import { motion } from 'framer-motion';

export default function PhoneFrame({ src, alt, center = false, delay = 0 }) {
  return (
    <motion.div
      data-testid={center ? 'phone-frame-center' : `phone-frame-${alt?.slice(0, 12).replace(/\s/g, '-')}`}
      initial={{ opacity: 0, y: 60, rotate: center ? 0 : 2 }}
      whileInView={{ opacity: 1, y: 0, rotate: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={`relative ${center ? 'z-10 scale-110' : 'z-0 opacity-90'}`}
    >
      {center && (
        <div className="absolute -inset-8 bg-[#e8173a]/25 blur-3xl rounded-full pointer-events-none" aria-hidden="true" />
      )}
      <div className="relative w-full aspect-[9/19] rounded-[2rem] border border-white/15 bg-[#0d0d0d] p-1.5 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)]">
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-20 h-4 bg-black rounded-full z-10 border border-white/10" />
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="w-full h-full object-cover rounded-[1.7rem]"
        />
        <div className="absolute inset-1.5 rounded-[1.7rem] bg-gradient-to-t from-[#0d0d0d]/70 via-transparent to-transparent pointer-events-none" />
      </div>
    </motion.div>
  );
}
